export const ViewingRestrictionStatusEnum = Object.freeze({
    NONE: 'NONE',
    WARNING: 'WARNING',
    RESTRICTED: 'RESTRICTED'
});

export default ViewingRestrictionStatusEnum;
